import styled from "styled-components";

export const BookingSkecheduleStyled = styled.div`
  .booking_box {
    border: 1px solid black;
    padding: 15px 15px 20px 15px;
    .booking_show {
      margin-bottom: 14px;
      padding: 5px 20px;
      border-radius: 50px;
      border: none;
      background-color: ${({ statusColor }) => statusColor};
      text-align: center;
      color: ${({ textColor }) => textColor};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
    .booking_detail {
      margin-bottom: 20px;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      .name_label {
        margin-bottom: 4px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      }
      .booking_note {
        margin-top: 4px;
        white-space: pre-wrap;
        word-break: break-word;
      }
      /* แจ้งเตือนว่าแอดมินเปลี่ยนวันจัดงาน - ใช้โทนส้มบอกว่าเป็นข้อมูลสำคัญ ไม่ใช่ error */
      .booking_date_changed {
        margin-top: 10px;
        border-radius: 8px;
        padding: 8px 12px;
        background: ${({ theme }) => theme.COLORS.ORANGE_2};
        color: ${({ theme }) => theme.COLORS.GRAY_4};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        .bdc_title {
          color: ${({ theme }) => theme.COLORS.YELLOW_2};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
        }
        .bdc_reason {
          margin-top: 2px;
          line-height: 1.4;
        }
      }
    }
    .booking_payment {
      margin-bottom: 20px;
      padding: 10px 20px;
      border-radius: 10px;
      background-color: ${({ theme }) => theme.COLORS.GRAY_1};
      .booking_paymentdetail {
        margin-bottom: 4px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      }
      .booking_pleasetransfer {
        display: flex;
        justify-content: space-between;
        column-gap: 6px;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      }
    }
    .booking_cancelbutton {
      margin: auto;
      border: none;
      border-radius: 50px;
      border: 1px solid ${({ theme }) => theme.COLORS.RED_1};
      padding: 8px 20px;
      max-width: 177px;
      background-color: ${({ theme }) => theme.COLORS.WHITE_1};
      text-align: center;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background-color: ${({ theme }) => theme.COLORS.RED_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        border: 1px solid ${({ theme }) => theme.COLORS.RED_1};
      }
    }

    .booking_detail_button {
      margin: auto;
      margin-bottom: 15px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_11};
      border-radius: 24px;
      padding: 8px 20px;
      max-width: 177px;
      background-color: ${({ theme }) => theme.COLORS.WHITE_1};
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_11};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      cursor: pointer;
      transition: 0.3s;
      &:hover {
        background-color: ${({ theme }) => theme.COLORS.PURPLE_11};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
      }
    }
    /* ปุ่มแจ้งการชำระเงิน เป็น action หลัก ใช้พื้นทึบให้เด่นกว่าปุ่มรายละเอียด */
    .booking_payment_button {
      background-color: ${({ theme }) => theme.COLORS.PURPLE_11};
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      &:hover {
        opacity: 0.85;
      }
    }
    .booking_admin_edit {
      margin-bottom: 15px;
      padding: 0px 20px;
      color: ${({ theme }) => theme.COLORS.RED_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
  }

  /* popup แจ้งการชำระเงิน (อยู่นอก .booking_box) */
  .payment_modal {
    border-radius: 12px;
    padding: 16px;
    width: 100%;
    max-width: 480px;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.COLORS.WHITE_1};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    .pm_header {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .pm_title {
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      }
      .pm_close {
        /* ขยายพื้นที่กดให้กดง่ายบนมือถือ */
        margin: -8px;
        padding: 8px;
        display: flex;
        cursor: pointer;
      }
    }
    .pm_list {
      margin-bottom: 16px;
      .pm_list_title {
        margin-bottom: 8px;
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .pm_item {
        margin-bottom: 8px;
        border: 1px solid ${({ theme }) => theme.COLORS.GRAY_1};
        border-radius: 8px;
        padding: 8px 12px;
      }
      .pm_row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        column-gap: 8px;
        & + .pm_row {
          margin-top: 4px;
        }
      }
      .pm_amount {
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .pm_status {
        color: #ff8900;
        &.verified {
          color: #3f830d;
        }
      }
      .pm_link {
        color: ${({ theme }) => theme.COLORS.PURPLE_11};
        text-decoration: underline;
      }
    }
    .booking_detail_button {
      margin: auto;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_11};
      border-radius: 24px;
      padding: 8px 20px;
      max-width: 177px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_11};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      cursor: pointer;
    }
  }

  &.theme_standard {
  }
`;
